export interface Profile {
  approved: true;
  id: string;
  name: string;
  role: string;
  bio: string;
  portrait: string;
  alt: string;
}

export interface JobOpening {
  approved: true;
  id: string;
  title: string;
  summary: string;
  responsibilities: string[];
  requirements: string[];
  location: string;
  workingArrangement: string;
  employmentType: string;
  applicationUrl: string;
}

export interface GeneralInterestConfig {
  url: string;
  linkText: string;
  label: string;
  description: string;
}

// Arrays MUST be empty initially, as no explicit profiles or jobs are approved yet.
export const profiles: Profile[] = [];

export const jobOpenings: JobOpening[] = [];

// General company contact fallback only; replace with an owner-approved
// general-interest destination and accurate handling description when supplied.
export const generalInterestConfig: GeneralInterestConfig = {
  url: "mailto:office@plasmics.com",
  linkText: "office@plasmics.com",
  label: "General Company Contact",
  description: "Interested in Plasmics? For general questions, you can contact the company below. This is a general company address, not a verified recruitment inbox or an application channel."
};
